import * as z from 'zod';
import { numericFieldSchema, shipSchema, Ship } from '@ais-ui/utils';
import { latLonToShape } from '@ais-ui/react-openlayers';
import {
  Destination,
  TrackPost,
  TrackResult,
} from '@ais-ui/api-spec/portserver';

export const mutateRouteFormSchema = z.object({
  sourceShip: shipSchema
    .nullish()
    .refine((ship): ship is Ship => !!ship && (!!ship.name || !!ship.mmsi), {
      message: 'Please select a vessel',
    }),
  latitude: numericFieldSchema.optional(),
  longitude: numericFieldSchema.optional(),
  destinationShapeId: z.string(),
  destinationPortId: z.string(),
});

export type MutateRouteFormValues = z.infer<typeof mutateRouteFormSchema>;

export const convertBackendValuesToRoute = (
  route: TrackResult,
): MutateRouteFormValues => {
  return {
    sourceShip: {
      name: route?.source?.ship?.name ? route.source.ship.name : '',
      mmsi: route?.source?.ship?.mmsi
        ? route.source.ship.mmsi.toString()
        : null,
      callSign: null,
      imo: null,
      type: null,
    },
    latitude: route?.destination?.position?.coordinates[1]
      ? (route.destination.position.coordinates[1] as number)
      : undefined,
    longitude: route?.destination?.position?.coordinates[0]
      ? (route.destination.position.coordinates[0] as number)
      : undefined,
    destinationShapeId: route?.destination?.location?.id
      ? route.destination.location.id
      : '',
    destinationPortId: route?.destination?.port?.id
      ? route.destination.port.id.toString()
      : '',
  };
};

export const convertRouteValuesToBackend = (
  data: MutateRouteFormValues,
): TrackPost => {
  let destination: Destination;
  if (data.destinationPortId) {
    destination = { port: { id: Number(data.destinationPortId) } };
  } else if (data.destinationShapeId) {
    destination = { location: { id: data.destinationShapeId } };
  } else if (data.latitude && data.longitude) {
    const point = latLonToShape(data.latitude, data.longitude);
    destination = {
      position: point.geometry,
    };
  } else {
    throw new Error('No destination provided');
  }

  return {
    source: {
      ship: {
        name: data.sourceShip?.name ? data.sourceShip.name : '',
        mmsi: data.sourceShip?.mmsi ? Number(data.sourceShip.mmsi) : undefined,
      },
    },
    destination: destination,
    erp: {},
    eta: '',
    id: '',
  };
};
